<template>
  <teleport to="body">
    <div v-if="modelValue" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-delete" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">{{ header }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hideModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img src="../../assets/gifs/DeclineGif.gif" alt="Trash" height="90">
              <h6 class="mt-2">{{subHeader}}</h6>
              <p class="mb-0" style="font-size: 16px; margin-top: 15px;">{{confirmationMessage }}</p>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" class="btn btn-grey mr-2" @click="hideModal">{{ $t('general.button.no') }}</button>
            <button type="button" class="btn btn-danger ml-2 pl-4 pr-4" @click="onConfirm">{{ $t('general.button.yes_confirm') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modelValue" class="modal-backdrop fade show"></div>
  </teleport>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

 const { t } = useI18n();
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  header: {
    type: String,
    default: '',
  },
  subHeader:{
    type: String,
    default: '',
  },
  confirmationQuestion:{
    type: String,
    default: ""
  },
  onConfirm: {
    type: Function,
    default: () => {
    },
  },
});

const confirmationMessage = computed(() => props.confirmationQuestion || t('general.approve_question'));

const emit = defineEmits([ 'update:modelValue' ]);
const hideModal = () => {
  emit('update:modelValue', false);
};
</script>

<style scoped>
</style>